module.exports = __webpack_public_path__ + "static/android-chrome-192x192-8ba44b9770d7073f0fdbafed14e71314.png";